module.exports = __webpack_public_path__ + "static/media/IMC.df3dafb3.png";